import React from "react";
import { Link } from "react-router-dom";
import CustomInput from "../../components/Form/Input";
import CustomButton from "../../components/Form/CustomButtonWithHover";
import { resetPassword } from "../../store";
import { useThunk } from "../../hooks/useThunk";
import useForm from "../../hooks/useForm";
import { COMMON_FIELD_TYPES } from "../../constants/fieldTypes";
import showToast from "../../utils/toastNotifications";

const ForgotPassword = () => {
  const [doResetPassword, isResettingPassword] = useThunk(resetPassword);

  const {
    formData,
    errors,
    touched,
    handleInputChange,
    handleBlur,
    validateForm,
    setTouched,
    clearError,
  } = useForm(
    {
      emailOrPhone: "",
    },
    {
      emailOrPhone: true,
    },
    {
      emailOrPhone: COMMON_FIELD_TYPES.EMAIL_OR_PHONE,
    }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setTouched({ emailOrPhone: true });

    const isValid = validateForm();
    if (isValid) {
      const result = await doResetPassword({ email: formData.emailOrPhone });
      if (result?.success) {
        showToast("success", result?.response?.message || "Reset link sent");
      } else {
        showToast("error", result?.response?.message || "Failed to send link");
      }
    }
  };

  return (
    <div className="w-full h-auto  max-w-[516px] bg-white/80 p-6 rounded-[20px] shadow-[0px_4px_4px_rgba(0,0,0,0.25)]">
      <form className="flex flex-col" onSubmit={handleSubmit}>
        <h1 className="text-[30px] font-[650] text-[#4772F1] Alexandria ,sans-serif">
          Forgot Password?
        </h1>

        <p
          className="mt-[50px] text-[17px] font-[400] text-[#071952]"
          style={{ fontFamily: "Alexandria, sans-serif" }}
        >
          Enter your email address and we will send you a link to reset your
          password
        </p>

        <CustomInput
          label={
            <>
              E-mail Address<span style={{ color: "#FF0505" }}>*</span>
            </>
          }
          type="email"
          name="email"
          placeholder="Enter your email address"
          value={formData.emailOrPhone}
          error={touched.emailOrPhone && errors.emailOrPhone}
          onChange={(e) => handleInputChange("emailOrPhone", e.target.value)}
          onBlur={() => handleBlur("emailOrPhone", formData.emailOrPhone)}
          onFocus={() => clearError("emailOrPhone")}
          labelStyle="font-alexandria font-medium sm:text-[16px] text-dark mt-[39px]"
          className="h-[54px] mt-[12px] px-3 rounded-xl border border-gray-300 bg-primary-light/30 text-content placeholder-[#9D9D9D] placeholder:text-[16px] placeholder:leading-[20px] placeholder:font-normal"
        />

        <CustomButton
          type="submit"
          loading={isResettingPassword}
          className="h-[60px] w-full mt-[50px] rounded-xl text-white font-inter text-[18px] font-semibold bg-gradient-to-r from-[#4772F1] to-[#873FE2]"
          buttonText="Send Reset Link"
        />

        <div className="mt-[13px] text-center text-[15px] font-medium font-inter">
          <Link to="/signin">
            <span className="text-[#4772F1] font-alexandria sm:text-[16px] cursor-pointer underline">
              Back to Login
            </span>
          </Link>
        </div>
      </form>
    </div>
  );
};

export default ForgotPassword;
